import request from '@/utils/request'
const apiPath = '/course/courseSubject'
import { downloadBlob } from '@/utils/download'
const courseSubjectApi = {
  /**
   * 新增【课程管理】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【课程管理】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【课程管理】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  fetchForList(query) {
    return request.get(apiPath + '/tee/listPageForMini', { params: query })
  },
  fetchForOptions(query) {
    return request.get(apiPath + '/options', { params: query })
  },
  /**
   *
   * 查看【课程管理】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【课程管理】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  batchState(data) {
    return request.post(apiPath + '/batchState', data, { isFormData: 1 })
  },
  batchRecommend(data) {
    return request.post(apiPath + '/setRecommend', data, { isFormData: 1 })
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '课程管理.xlsx'))
  },
  courseImport(data) {
    return request.post(apiPath + '/import', data)
  },
  getCourseSubjectStatistics(data){
    return request.post(apiPath + '/getCourseSubjectStatistics', data, { isFormData: 1 })
  },
  getRankPage(query){
    return request.get(`${apiPath}/tee/rankPage`, { params: query })
  },
  // 导出【课程排名】excel
  exportExcels(query) {
   return request.get(`${apiPath}/courseRanking`, { params: query })
  },
}
export default courseSubjectApi
